import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Alerts, Btn, H5, P } from "../../../AbstractElements";
import { CustomAlertPopupTitle } from "../../../Constants/Constants";
import { CustomAlertPopupSubTitle } from "../../../Data/UiKits/Alert";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import SvgIcon from "../../CommonComponents/SvgIcon/SvgIcon";

const CustomAlertPopup = () => {
  const [active, setActive] = useState(true);
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={CustomAlertPopupTitle} span={CustomAlertPopupSubTitle} />
        <CardBody>
        <div className="alert-box">
          <Alerts color="transparent" isOpen={active} className={`alert alert-dismissible justify-content-center p-0 fade`}>
            <div className="alert-body">
                <SvgIcon iconId="alert-popup" />
              <H5 className="mb-1">A Crucial Update is Now Available</H5>
              <P>For improved security and functionality, install the most recent version right away.</P>
              <div className="button-box">
                <Btn color="light">Later</Btn>
                <Btn color="warning">Right Now</Btn>
              </div>
            </div>
            <Btn color="transparent" close onClick={() => setActive(false)} />
          </Alerts>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CustomAlertPopup;
